import { FC, useState } from "react";
import styled from "styled-components";
import { color } from "@styles";
import { tablet } from "components/templates/Breakpoints";
import { CONTINENTS } from "./ContinentBar";

interface ContinentButton {
  continent: string;
  isSelected: boolean;
  onClick: () => void;
  index: number;
}

export const ContinentButton: FC<ContinentButton> = ({ continent, isSelected, onClick, index }) => {
  return (
    <Button
      onClick={onClick}
      isSelected={isSelected}
      isFirst={index === 0}
      isLast={index === CONTINENTS.length - 1}
    >
      <Title isSelected={isSelected}>{continent}</Title>
    </Button>
  );
};

const Button = styled.button<{ isSelected: boolean; isFirst: boolean; isLast: boolean }>`
  width: 9.375rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(p) => (p.isSelected ? color.S3100 : color.S320)};
  box-shadow: ${color.S320} 0.25rem 0.25rem 0;
  cursor: pointer;
  border: 1px ${color.S3100} solid;
  border-left-width: 1px;
  border-right: 0;

  &:hover {
    background: ${(p) => (p.isSelected ? color.S3100 : color.S340)};
  }

  ${(p) =>
    p.isFirst
      ? `
          border-radius: 0.5rem 0 0 0.5rem;
          border-left: 1px ${color.S3100} solid;
        `
      : null};

  ${(p) =>
    p.isLast
      ? `
          border-radius: 0 0.5rem 0.5rem 0;
          border-right: 1px ${color.S3100} solid;
          `
      : null};

  ${tablet} {
    height: 2rem;
  }
`;

const Title = styled.p<{ isSelected: boolean }>`
  color: ${(p) => (p.isSelected ? color.white : color.S3100)};
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25rem;
  letter-spacing: 0.063rem;
  height: 100%;
  width: 100%;

  ${tablet} {
    font-size: 0.75rem;
    line-height: 0.8rem;
  }
`;
